import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboTipoPublicoPrioritarioComponent } from './combo-tipo-publico-prioritario.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboTipoPublicoPrioritarioComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboTipoPublicoPrioritarioComponent]
})
export class ComboTipoPublicoPrioritarioModule { }
